import { Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';
import { IProductItem } from '@x/ecommerce-shop/app/core/product/types/product-item';

@Pipe({
  name: 'searchQParams',
  standalone: true,
})
export class SearchQParamsPipe implements PipeTransform {
  transform({ searchContext }: IProductItem): Params | undefined {
    const { queryId, queryIndex, objectId, position } = searchContext;

    if (!queryIndex || !queryId || !objectId || !position) return;

    return { queryId, queryIndex, objectId, position };
  }
}
